<div [ngClass]="{ rtl: this.direction === 'rtl' }" class="wrapper">
  @if (appUrl) {
    <iframe
      #appIframe
      (load)="iframeLoaded()"
      [src]="saveAppUrl"
      allow="microphone; camera;"
      allowfullscreen=""
      loading="lazy"
      sandbox="allow-forms allow-scripts allow-modals allow-popups allow-same-origin allow-downloads"
      title="client content">
    </iframe>
  }
</div>
